import { Button as Button$1 } from '@shopify/ui-extensions/checkout';
import { createRemoteReactComponent } from '@remote-ui/react';

const Button = createRemoteReactComponent(Button$1, {
  fragmentProps: ['overlay']
});

export { Button };
